/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PromotionCampaignPrizeAmountMode = {
    STATIC: 'STATIC',
    TICKET_COST_MULTIPLIER: 'TICKET_COST_MULTIPLIER',
    unknown_default_open_api: '11184809'
} as const;
export type PromotionCampaignPrizeAmountMode = typeof PromotionCampaignPrizeAmountMode[keyof typeof PromotionCampaignPrizeAmountMode];


export function instanceOfPromotionCampaignPrizeAmountMode(value: any): boolean {
    for (const key in PromotionCampaignPrizeAmountMode) {
        if (Object.prototype.hasOwnProperty.call(PromotionCampaignPrizeAmountMode, key)) {
            if (PromotionCampaignPrizeAmountMode[key as keyof typeof PromotionCampaignPrizeAmountMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PromotionCampaignPrizeAmountModeFromJSON(json: any): PromotionCampaignPrizeAmountMode {
    return PromotionCampaignPrizeAmountModeFromJSONTyped(json, false);
}

export function PromotionCampaignPrizeAmountModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionCampaignPrizeAmountMode {
    return json as PromotionCampaignPrizeAmountMode;
}

export function PromotionCampaignPrizeAmountModeToJSON(value?: PromotionCampaignPrizeAmountMode | null): any {
    return value as any;
}

